(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/start.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/start.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.Start = Marionette.View.extend({
    className: 'start',

    template: function() {
      return '';
    },

    initialize: function() {
      if (this.collection.models.length > 0) {
        this.initDayTabs();
      }
    },

    initDayTabs: function() {
      var dayTabs = [];

      var drawsByDay = this.collection.getDrawsByDate();

      _.each(
        drawsByDay,
        function(draws) {
          dayTabs.push(this.initDayTab(draws));
        },
        this
      );

      this.slider = new svs.app.tab_view.TabView({
        tabs: dayTabs,
        doNotSetHeight: false,
        selected: this.options.tab,
        path: true
      });

      this.listenTo(this.slider, 'onChange', this.onSlideChange);
    },

    onSlideChange: function(arg) {
      var caption =
        arg &&
        arg.currentView &&
        arg.currentView.caption &&
        arg.currentView.caption.toLowerCase();

      if (caption) {
        svs.matchen.router.saveTab(arg.currentView.caption.toLowerCase());

        svs.matchen.router.navigate(
          '/' + arg.currentView.caption.toLowerCase(),
          { trigger: false, replace: true }
        );
      }
    },

    initDayTab: function(draws) {
      var col = new Backbone.Collection(draws);
      var tab = {};
      var caption = svs.utils.date.getLocalizedWeekday(col.models[0].get('regCloseTime'));

      tab.caption = caption.charAt(0).toUpperCase() + caption.slice(1);
      tab.id = 'tab-' + dateFns.getTime(col.models[0].get('regCloseTime'), 'yyMMdd');
      tab.view = new svs.matchen.views.DrawList({
        collection: col,
        childViewOptions: { showNetSales: true, linkToDraw: true }
      });

      return tab;
    },

    onRender: function() {
      if (this.slider) {
        this.$el.html(this.slider.el);
      } else {
        this.$el.html(svs.matchen.templates.no_open_draws());
      }
    },

    onDestroy: function() {
      if (svs.core.detect.formfactor.mobile()) {
        svs.components.contextualMenu.reset();
      }

      this.destroySlider();

      if (this.$el) {
        this.$el.empty();
      }
    },

    destroySlider: function() {
      this.slider.destroy();
      this.slider = null;
      delete this.slider;
    }
  });
})(Backbone, _, svs);


 })(window);